// extracted by mini-css-extract-plugin
module.exports = {"promoMessage_root":"promoMessage_root-1ovhP","header":"header-3Lldi","upgrade_block":"upgrade_block-3cFbL"};